import { useEffect, useState } from "react";

/**
 * An object URL for a Blob (a fetched picture, or a File chosen for a preview), made when
 * the Blob changes and revoked when it changes again or the component unmounts, so a
 * picture's bytes are not kept alive after nothing shows them.
 */
export function useObjectUrl(blob: Blob | undefined | null): string | undefined {
  const [current, setCurrent] = useState<{ blob: Blob; url: string }>();
  useEffect(() => {
    if (!blob) return;
    const url = URL.createObjectURL(blob);
    // The URL exists only once the effect has run; state carries it to the render.
    // eslint-disable-next-line react-hooks/set-state-in-effect
    setCurrent({ blob, url });
    return () => URL.revokeObjectURL(url);
  }, [blob]);
  // A URL made for an earlier Blob is never shown for a new one.
  return blob && current?.blob === blob ? current.url : undefined;
}
